/* eslint-disable */

<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vue-command
          id="command_prompt"
          :commands="commands"
          prompt="[root@rapid-simulations ~]>"
          class="rounded-lg main-border"
          intro="Type [help] to show available commands"
          :show-intro="true"
          style="background-color: #111111"
          title="Command Prompt"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      commands: {
        mema: () => createStdout('Is the best developer in the world'),
        help: () =>
          createStdout(
            'Available commands:<br>kill -9 &#60;pid&#62;<br>ps -A<br>chkconfig --list<br>chkconfig --level 3 &#60;service name&#62; &#60;on|off><br>service &#60;service name&#62; &#60;start|stop>',
          ),
        ps: () => undefined,
        chkconfig: () => undefined,
        kill: () => undefined,
      },

      ranPSA: false,
      ranChkConfigList: false,
      openPorts: [2077, 9343, 9345, 1652, 1761, 1776, 5829, 8080],
      closedPorts: [],
      services: ['bluetooth', 'httpd', 'irda', 'lpd', 'mysqld', 'sendmail', 'wpa_supplicant'],
      checkedServices: [],
    };
  },
  methods: {
    checkSimulationComplete() {
      let complete = true;
      if (this.ranPSA === false) complete = false;
      if (this.ranChkConfigList === false) complete = false;
      if (this.openPorts.length !== 0) complete = false;
      if (this.services.length !== 0) complete = false;

      if (complete === true) {
        this.$emit('simulation_full_correct', 1);
      }
    },
  },
  mounted() {
    // Disable Mark Button and Update Options in Renderer
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);

    // Mount Needed Sounds
    this.currently_downloading_sound = new Audio('https://sims-cdn.intellectualpoint.com/sounds/effect/SoundDL.mp3');
    this.uac_sound = new Audio('https://sims-cdn.intellectualpoint.com/sounds/effect/Windows_11_UAC_Sound.mp3');

    this.commands.ps = (x) => {
      if (x.A !== true) {
        return createStderr('<span class="text-danger">‎ ‎ ‎  %‎‎ ‎‎ Invalid Command.</span>');
      }

      this.ranPSA = true;
      return createStdout(
        'PID TTY ‎ ‎ ‎   ‎ ‎ ‎  TIME CMD<br>' +
          ' ‎  ‎ 1 ? ‎ ‎ ‎   ‎ ‎00:00:15 init<br>' +
          ' ‎  ‎ 2 ? ‎ ‎ ‎   ‎ ‎00:00:00 kthreadd<br>' +
          ' ‎  ‎ 3 ? ‎ ‎ ‎   ‎ ‎00:00:00 migration/0<br>' +
          ' ‎  ‎ 5 ? ‎ ‎ ‎   ‎ ‎00:00:00 watchdog/0<br>' +
          ' ‎  ‎ 6 ? ‎ ‎ ‎   ‎ ‎00:00:00 migration/1<br>' +
          ' ‎  ‎ 7 ? ‎ ‎ ‎   ‎ ‎00:00:00 ksofttirqd/1<br>' +
          ' ‎  ‎ 8 ? ‎ ‎ ‎   ‎ ‎00:00:00 watchdog/1<br>' +
          ' ‎  ‎ 9 ? ‎ ‎ ‎   ‎ ‎00:00:00 events/0<br>' +
          ' ‎  ‎10 ? ‎ ‎ ‎   ‎ ‎00:00:00 events/1<br>' +
          ' ‎  ‎15 ? ‎ ‎ ‎   ‎ ‎00:00:00 kintegrityd/0<br>' +
          ' ‎  16 ? ‎ ‎ ‎   ‎ ‎00:00:00 kintegrityd/1<br>' +
          ' ‎  17 ? ‎ ‎ ‎   ‎ ‎00:00:00 kblockd/0<br>' +
          ' ‎  18 ? ‎ ‎ ‎   ‎ ‎00:00:00 kblockd/1<br>' +
          ' ‎  19 ? ‎ ‎ ‎   ‎ ‎00:00:00 kacpid<br>' +
          ' ‎  20 ? ‎ ‎ ‎   ‎ ‎00:00:00 kacpid_notify<br>' +
          ' ‎  21 ? ‎ ‎ ‎   ‎ ‎00:00:00 eta/0<br>' +
          ' ‎  22 ? ‎ ‎ ‎   ‎ ‎00:00:27 ata/1<br>' +
          ' ‎  23 ? ‎ ‎ ‎   ‎ ‎00:00:00 ata_aux<br>' +
          ' ‎  33 ? ‎ ‎ ‎   ‎ ‎00:00:00 crypto/0<br>' +
          ' ‎  34 ? ‎ ‎ ‎   ‎ ‎00:00:00 crypto/1<br>' +
          ' ‎  45 ? ‎ ‎ ‎   ‎ ‎00:00:00 scsi_eh_0<br>' +
          ' ‎  46 ? ‎ ‎ ‎   ‎ ‎00:00:00 scsi_eh_1<br>' +
          ' ‎  77 ? ‎ ‎ ‎   ‎ ‎00:00:00 scsi_eh_2<br>' +
          ' ‎  84 ? ‎ ‎ ‎   ‎ ‎00:00:35 kjournald<br>' +
          ' ‎  84 ? ‎ ‎ ‎   ‎ ‎00:00:03 kauditd<br>' +
          ' ‎ 937 ? ‎ ‎ ‎   ‎ ‎00:00:00 kjourland<br>' +
          ' 1447 ? ‎ ‎ ‎   ‎ ‎00:00:23 auditd<br>' +
          ' 1449 ? ‎ ‎ ‎   ‎ ‎00:00:17 audispd<br>' +
          ' 1480 ? ‎ ‎ ‎   ‎ ‎00:00:00 network<br>' +
          ' 1602 ? ‎ ‎ ‎   ‎ ‎00:00:00 acpid<br>' +
          `${this.openPorts.includes(1652) ? ' 1652 ? ‎ ‎ ‎   ‎ ‎00:00:00 wpa_supplicant' : ''}` +
          `${this.openPorts.includes(1761) ? ' 1761 ? ‎ ‎ ‎   ‎ ‎00:00:00 bluetoothd<br>' : ''}` +
          `${this.openPorts.includes(1776) ? ' 1776 ? ‎ ‎ ‎   ‎ ‎00:00:00 bluetooth' : ''}` +
          ' 1802 ? ‎ ‎ ‎   ‎ ‎00:00:10 ntpd<br>' +
          ' 2071 ? ‎ ‎ ‎   ‎ ‎00:00:15 crond<br>' +
          `${this.openPorts.includes(2077) ? ' 2077 ? ‎ ‎ ‎   ‎ ‎00:00:00 mysqld<br>' : ''}` +
          ' 2090 ? ‎ ‎ ‎   ‎ ‎00:00:00 named<br>' +
          ' 2187 ? ‎ ‎ ‎   ‎ ‎00:00:00 atd<br>' +
          ' 3343 ? ‎ ‎ ‎   ‎ ‎00:00:18 httpd<br>' +
          ' 3758 ? ‎ ‎ ‎   ‎ ‎00:00:00 sshd<br>' +
          ' 3759 pts/0  ‎ ‎00:00:00 bash<br>' +
          ' 3840 pts/0  ‎ ‎00:00:00 ps<br>' +
          `${this.openPorts.includes(5829) ? ' 5829 ? ‎ ‎ ‎   ‎ ‎00:00:15 sendmail<br>' : ''}` +
          `${this.openPorts.includes(8080) ? ' 8080 ? ‎ ‎ ‎   ‎ ‎00:00:00 lpd<br>' : ''}` +
          `${this.openPorts.includes(9343) ? ' 9343 ? ‎ ‎ ‎   ‎ ‎00:00:18 httpd<br>' : ''}` +
          `${this.openPorts.includes(9345) ? ' 9345 ? ‎ ‎ ‎   ‎ ‎00:00:00 httpd' : ''}`,
      );
    };

    this.commands.kill = (x) => {
      if (this.ranPSA !== true) {
        return createStderr('<span class="text-danger">‎Please run ps -A first</span>');
      }

      if (!x[9]) {
        return createStderr('<span class="text-danger">‎ ‎ ‎  %‎‎ ‎‎ Invalid Arguments.</span>');
      }

      if (!this.closedPorts.includes(x[9]) && !this.openPorts.includes(x[9])) {
        return createStderr('<span class="text-danger">‎ ‎ ‎  %‎‎ ‎‎ ‎Invalid Input Detected.</span>');
      }

      if (this.closedPorts.includes(x[9])) {
        return createStderr('<span class="text-danger">‎ ‎ ‎  %‎‎ ‎‎ PID Already Closed.</span>');
      }

      if (this.openPorts.includes(x[9])) {
        const index = this.openPorts.indexOf(x[9]);
        if (index > -1) {
          this.closedPorts.push(this.openPorts[index]);
          this.openPorts.splice(index, 1);
          return createStdout('<span class="text-success">‎ ‎ ‎  %‎‎ ‎‎ PID Killed.</span>');
        }
      }

      return createStderr('<span class="text-danger">‎ ‎ ‎  %‎‎ ‎‎ ‎Invalid Input Detected.</span>');
    };

    this.commands.chkconfig = (x) => {
      if (this.ranPSA !== true) {
        return createStderr('<span class="text-danger">‎Please run ps -A first</span>');
      }

      if (this.closedPorts.length === 0) {
        return createStderr('<span class="text-danger">‎Please run kill -9 and kill services first</span>');
      }

      if (x.list === true) {
        this.ranChkConfigList = true;
        return createStdout(
          'atd ‎ ‎ ‎3:on<br>' +
            `bluetooth ‎ ‎ ‎3:${this.services.includes('bluetooth') ? 'on' : 'off'}<br>` +
            'epuspeed ‎ ‎ ‎3:on<br>' +
            'CEond ‎ ‎ ‎3:on<br>' +
            `httpd ‎ ‎ ‎3:${this.services.includes('httpd') ? 'on' : 'off'}<br>` +
            'ip6tables ‎ ‎ ‎3:off<br>' +
            'iptables ‎ ‎ ‎3:on<br>' +
            `irda ‎ ‎ ‎3:${this.services.includes('irda') ? 'on' : 'off'}<br>` +
            'irqbalance ‎ ‎ ‎3:on<br>' +
            '1m_sensOES ‎ ‎ ‎3:off<br>' +
            `lpd ‎ ‎ ‎3:${this.services.includes('lpd') ? 'on' : 'off'}<br>` +
            'microcode_etl ‎ ‎ ‎3:on<br>' +
            'multipathd ‎ ‎ ‎3:off<br>' +
            `mysqld ‎ ‎ ‎3:${this.services.includes('mysqld') ? 'on' : 'off'}<br>` +
            'named ‎ ‎ ‎3:on<br>' +
            'netconsole ‎ ‎ ‎3:off<br>' +
            'netfs ‎ ‎ ‎3:on<br>' +
            'netplugd ‎ ‎ ‎3:off<br>' +
            'network ‎ ‎ ‎3:on<br>' +
            'nfs ‎ ‎ ‎3:on<br>' +
            'ntalock ‎ ‎ 3:on<br>' +
            'nsed ‎ ‎ ‎3:off<br>' +
            'ntpd ‎ ‎ ‎3:on<br>' +
            'ntpdate ‎ ‎ ‎3:off<br>' +
            'restorecond ‎ ‎ ‎<br>' +
            'rpebind ‎ ‎ ‎3:on<br>' +
            'rpegaad ‎ ‎ ‎3:on<br>' +
            'rpeidmapd ‎ ‎ ‎3:on<br>' +
            'rpesvegad ‎ ‎ ‎3:on<br>' +
            'rayalog ‎ ‎ ‎3:on<br>' +
            `sendmail ‎ ‎ ‎3:${this.services.includes('sendmail') ? 'on' : 'off'}<br>` +
            'smartd ‎ ‎ ‎3:off<br>' +
            'snmpd ‎ ‎ ‎3:off<br>' +
            'snmptrapd ‎ ‎ ‎3:off<br>' +
            'sshd ‎ ‎ ‎3:on<br>' +
            'udev-post ‎ ‎ ‎3:on<br>' +
            'winbind ‎ ‎ ‎3:off<br>' +
            `wpa_supplicant ‎ ‎ ‎3:${this.services.includes('wpa_supplicant') ? 'on' : 'off'}<br>` +
            'ypbind ‎ ‎ ‎3:off<br>',
        );
      }

      if (x.level) {
        if (this.ranChkConfigList !== true) {
          return createStderr('<span class="text-danger">‎Please run chkconfig --list first</span>');
        }

        if (x.level !== 3) {
          return createStderr('<span class="text-danger">‎Invalid arguments, Wrong or Missing Level</span>');
        }

        if (this.checkedServices.includes(x._[1])) {
          return createStderr('<span class="text-danger">‎ ‎ ‎  %‎‎ ‎‎ Service Already Disabled.</span>');
        }

        if (!this.services.includes(x._[1])) {
          return createStderr('<span class="text-danger">‎ ‎ ‎  %‎‎ ‎‎ ‎Invalid Service Detected.</span>');
        }

        if (x._[2] !== 'off') {
          return createStderr('<span class="text-danger">‎You must be turning a service off</span>');
        }

        if (this.services.includes(x._[1])) {
          const index = this.services.indexOf(x._[1]);
          if (index > -1) {
            this.checkedServices.push(this.services[index]);
            this.services.splice(index, 1);
            this.checkSimulationComplete();
            return createStdout('<span class="text-success">‎ ‎ ‎  %‎‎ ‎‎ Service Disabled.</span>');
          }
        }
      }

      return createStderr('<span class="text-danger">‎ ‎ ‎  %‎‎ ‎‎ ‎Invalid Input Detected.</span>');
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    Prism,
    VueCommand,
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
};
</script>
<style scoped></style>
